/* dirb-video.js — click-to-play for video posters (home rail `.dirb-vposter`, product-card video
 * mode `.pcard-vposter`, ranked-list header). BG-163b: a plain click opens ONE reused native
 * <dialog> (big player, game name, the card's own buy control moved in and back on close). No
 * iframe/video element exists, and no request for one fires, until that click. The server-rendered
 * <a href> poster links work without this file, and in browsers without <dialog>.showModal.
 * Modified/middle clicks are left alone so a new tab still opens. Any theme drawer that starts to
 * open (cart / quick add) closes the pop-up first.
 */
(function () {
  'use strict';

  // Several sections include this script: one controller per page.
  if (window.__dirbVideoInit) return;
  window.__dirbVideoInit = true;

  var dlg, head, title, frame, bar, art, price, buy, details, closeBtn;
  var opener, buyWrap, buyStyle, moved;

  function el(tag, cls, parent) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (parent) parent.appendChild(n);
    return n;
  }

  function build() {
    dlg = el('dialog', 'vpop', document.body);
    dlg.setAttribute('aria-labelledby', 'vpop-t');
    head = el('div', 'vpop__head', dlg);
    title = el('p', 'vpop__t', head);
    title.id = 'vpop-t';
    closeBtn = el('button', 'vpop__x', head);
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', (window.theme && theme.strings && theme.strings.close) || 'Close');
    closeBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';
    frame = el('div', 'vpop__frame', dlg);
    bar = el('div', 'vpop__bar card--product', dlg);
    art = el('div', 'vpop__artwrap', bar);
    price = el('div', 'vpop__price', bar);
    buy = el('div', 'vpop__buy', bar);
    details = el('a', 'vpop__details', bar);
    details.textContent = (window.theme && theme.strings && theme.strings.viewDetails) || 'View details';

    closeBtn.addEventListener('click', function () { shut(true); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) shut(true); });
    dlg.addEventListener('close', function () { if (!dlg.open) shut(true); });
    // A theme drawer is about to open: close first so the drawer is not hidden under the modal.
    ['on:cart-drawer:before-open', 'on:quickbuy:before-open'].forEach(function (name) {
      document.addEventListener(name, function () { if (dlg.open) shut(false); });
    });
  }

  function shut(restoreFocus) {
    if (!opener) return;
    var o = opener;
    opener = null;
    frame.textContent = '';
    if (moved) {
      // a cart error shown in the pop-up must not follow the form back into the card
      var err = buy.querySelector('.js-form-error');
      if (err) { err.hidden = true; err.textContent = ''; }
      while (buy.firstChild) buyWrap.appendChild(buy.firstChild);
      if (buyStyle === null) buyWrap.removeAttribute('style');
      else buyWrap.setAttribute('style', buyStyle);
    }
    moved = false;
    buyWrap = null;
    art.textContent = '';
    price.textContent = '';
    bar.hidden = true;
    if (dlg.open) dlg.close();
    removeTrapFocus(restoreFocus ? o : null);
  }

  function open(link, template) {
    if (!dlg) build();
    if (opener) shut(false);
    opener = link;
    title.textContent = link.dataset.name || link.dataset.title || '';
    var player = template.content.firstElementChild.cloneNode(true);
    if (link.dataset.title) player.title = link.dataset.title;
    frame.appendChild(player);

    var card = link.closest('product-card');
    var rail = link.closest('.dirb-vcard');
    bar.hidden = !(card || rail);
    bar.classList.toggle('vpop__bar--rail', !card);
    if (card) {
      var img = card.querySelector('.pcard-vstamp img');
      if (img) art.appendChild(img.cloneNode(true)).className = 'vpop__art';
      var pl = card.querySelector('.pcard-priceline');
      if (pl) price.appendChild(pl.cloneNode(true));
      buyWrap = card.querySelector('.pcard-atc-wrap');
      if (buyWrap) {
        buyStyle = buyWrap.getAttribute('style');
        buyWrap.style.minHeight = buyWrap.offsetHeight + 'px';
        while (buyWrap.firstChild) buy.appendChild(buyWrap.firstChild);
        moved = true;
      }
    }
    details.href = link.href;
    details.hidden = !(card || rail);
    dlg.showModal();
    trapFocus(dlg, closeBtn);
  }

  document.addEventListener('click', function (event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
    var link = event.target.closest('.dirb-vposter, .pcard-vposter');
    if (!link) return;
    var wrap = link.closest('.dirb-vposter-wrap, .pcard-vwrap');
    if (!wrap) return;
    var template = wrap.querySelector('template');
    if (!template || !template.content || !template.content.firstElementChild) return;
    if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
    event.preventDefault();
    open(link, template);
  });
})();
